import { Button } from '@progress/kendo-react-buttons'
import { SearchBody } from '../../../components/layouts'
import { useAccessibleAuthority, usePageTitle } from '../../../components/hooks'
import AuthSearchCondition from './AuthSearchCondition'
import AuthSearchResultList from './AuthSearchResultList'
import { Authority } from '../../../gateway/system/Authority'

export default function AuthSearch() {
  useAccessibleAuthority(Authority.Builder, Authority.Material, Authority.Branch)
  usePageTitle('利用者権限マスタメンテナンス')

  return (
    <SearchBody
      leftPane={<AuthSearchCondition />}
      rightPane={<AuthSearchResultList />}
      rightPaneButton={
        <>
          <Button onClick={() => ''}>戻る</Button>
        </>
      }
    />
  )
}
